import { RouteRecordRaw } from 'vue-router'
import BaseLayoutView from '@/views/layout/BaseLayoutView.vue'
import ExportReport from '@/views/keiei-joho/soneki-keisan/SonekiKeisanExportReport.vue'
import Setting from '@/views/keiei-joho/soneki-keisan/SonekiKeisanSettings.vue'

export const sonekiKeisanRoute: RouteRecordRaw = {
  path: '/keiei',
  component: BaseLayoutView,
  children: [
    {
      path: 'soneki-keisan',
      children: [
        { path: 'export', component: ExportReport },
        { path: 'setting', component: Setting }
      ]
    }
  ]
}
